// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"3421e4f4","498":"2d26ab06","513":"53af24b9","703":"1259aec8"}[chunkId] + ".chunk.js";
};